export interface ReceiptState {
  sale: Sale | null;
  saleId: string | undefined;
  isSaleVisible: boolean;
  isCustomerInfoViewVisible: boolean;
  tip: Tip | null;
  paymentState?: PaymentState | null;
}

export enum PaymentState {
  PAYMENT_STARTED = 'Payment Started',
}
export interface Sale {
  saleID: number;
  ticketNumber: number;
  calcTax1: number;
  calcTax2: number;
  calcDiscount: number;
  calcTotal: number;
  calcSubtotal: number;
  calcTips?: number | null | undefined;
  taxTotal: number;
  completed: boolean;
  archived: boolean;
  voided: boolean;
  createTime: string;
  updateTime: string;
  quoteID: number;
  Customer?: Customer;
  SaleLines?: {
    SaleLine?: SaleLine[];
  };
  TaxClassTotals?: {
    Tax: Tax[];
  };
  paymentType: string;
  change: number;
}

export interface TipOption {
  id: string;
  value: number;
}

export interface Tip {
  tipOptions: TipOption[];
  customTip: boolean;
  paymentTotal: number;
  tippableAmount: number;
  enteredTip: {
    tipId: string | null;
    tipAmount: number | null;
    totalAmountWithTip: number;
  };
}

export interface TipRequest extends Omit<Tip, 'enteredTip'> {}

type ContactUseType = 'Primary' | 'Secondary';
type PhoneType = 'Home' | 'Work' | 'Mobile';
interface ContactEmail {
  address: string;
  useType: ContactUseType;
}

interface ContactPhone {
  number: string;
  useType: PhoneType;
}

interface Contact {
  Emails: '' | { ContactEmail: ContactEmail | ContactEmail[] };
  Phones: '' | { ContactPhone: ContactPhone | ContactPhone[] };
}
interface Customer {
  customerID: string;
  firstName: string;
  lastName: string;
  company: string;
  Contact: Contact;
}

interface WorkOrder {
  workOrderType: 'parent' | 'labour' | 'item';
}
interface WorkOrderItem {
  tax: boolean;
  saleLineID: number;
  unitPrice: number;
  normalUnitPrice: number;
  displayableSubtotal: number;
  calcLineDiscount: number;
  unitQuantity: number;
  Item?: Item;
}
export interface SaleLine {
  workOrder?: WorkOrder;
  tax: boolean;
  saleLineID: number;
  unitPrice: number;
  normalUnitPrice?: number;
  displayableSubtotal: number;
  calcLineDiscount: number;
  unitQuantity: number;
  Item?: Item;
  items?: WorkOrderItem[];
  Note?: Note;
  Discount?: Discount;
}

interface Item {
  description: string;
}

interface Note {
  note: string;
}

export interface Discount {
  name: string;
  discountAmount: number;
  discountPercent: number;
}

interface Tax {
  id: string;
  rate: number;
  amount: number;
  taxname: string;
  subtotal: number;
  rate2: number;
  amount2: number;
  taxname2: string;
  subtotal2: number;
}
